/**
 * Generated by @openapi-codegen
 *
 * @version v1
 */
import * as reactQuery from "@tanstack/react-query";
import { useCalendarContext, CalendarContext } from "./calendarContext";
import type * as Fetcher from "./calendarFetcher";
import { calendarFetch } from "./calendarFetcher";
import type * as Schemas from "./calendarSchemas";

export type ListGoogleAccountsError = Fetcher.ErrorWrapper<undefined>;

export type ListGoogleAccountsResponse = {
  google_accounts: {
    data: Schemas.GoogleAccount[];
  };
};

export type ListGoogleAccountsVariables = CalendarContext["fetcherOptions"];

export const fetchListGoogleAccounts = (
  variables: ListGoogleAccountsVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListGoogleAccountsResponse,
    ListGoogleAccountsError,
    undefined,
    {},
    {},
    {}
  >({ url: "/google_accounts", method: "get", ...variables, signal });

export const useListGoogleAccounts = <TData = ListGoogleAccountsResponse,>(
  variables: ListGoogleAccountsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListGoogleAccountsResponse,
      ListGoogleAccountsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ListGoogleAccountsResponse,
    ListGoogleAccountsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/google_accounts",
      operationId: "listGoogleAccounts",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListGoogleAccounts({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ShowGoogleAccountPathParams = {
  /**
   * Google Account ID
   */
  id: string;
};

export type ShowGoogleAccountError = Fetcher.ErrorWrapper<undefined>;

export type ShowGoogleAccountResponse = {
  google_calendars: {
    data: Schemas.GoogleCalendar[];
  };
};

export type ShowGoogleAccountVariables = {
  pathParams: ShowGoogleAccountPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchShowGoogleAccount = (
  variables: ShowGoogleAccountVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ShowGoogleAccountResponse,
    ShowGoogleAccountError,
    undefined,
    {},
    {},
    ShowGoogleAccountPathParams
  >({ url: "/google_accounts/{id}", method: "get", ...variables, signal });

export const useShowGoogleAccount = <TData = ShowGoogleAccountResponse,>(
  variables: ShowGoogleAccountVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ShowGoogleAccountResponse,
      ShowGoogleAccountError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ShowGoogleAccountResponse,
    ShowGoogleAccountError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/google_accounts/{id}",
      operationId: "showGoogleAccount",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowGoogleAccount({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type DeleteGoogleAccountPathParams = {
  /**
   * Google Account ID
   */
  id: string;
};

export type DeleteGoogleAccountError = Fetcher.ErrorWrapper<undefined>;

export type DeleteGoogleAccountVariables = {
  pathParams: DeleteGoogleAccountPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchDeleteGoogleAccount = (
  variables: DeleteGoogleAccountVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    undefined,
    DeleteGoogleAccountError,
    undefined,
    {},
    {},
    DeleteGoogleAccountPathParams
  >({ url: "/google_accounts/{id}", method: "delete", ...variables, signal });

export const useDeleteGoogleAccount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteGoogleAccountError,
      DeleteGoogleAccountVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    undefined,
    DeleteGoogleAccountError,
    DeleteGoogleAccountVariables
  >({
    mutationFn: (variables: DeleteGoogleAccountVariables) =>
      fetchDeleteGoogleAccount({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type EnableGoogleAccountPathParams = {
  /**
   * Google Account ID
   */
  id: string;
};

export type EnableGoogleAccountError = Fetcher.ErrorWrapper<undefined>;

export type EnableGoogleAccountResponse = {
  google_account: {
    data: Schemas.GoogleAccount;
  };
};

export type EnableGoogleAccountVariables = {
  pathParams: EnableGoogleAccountPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchEnableGoogleAccount = (
  variables: EnableGoogleAccountVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    EnableGoogleAccountResponse,
    EnableGoogleAccountError,
    undefined,
    {},
    {},
    EnableGoogleAccountPathParams
  >({
    url: "/google_accounts/{id}/enable",
    method: "post",
    ...variables,
    signal,
  });

export const useEnableGoogleAccount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      EnableGoogleAccountResponse,
      EnableGoogleAccountError,
      EnableGoogleAccountVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    EnableGoogleAccountResponse,
    EnableGoogleAccountError,
    EnableGoogleAccountVariables
  >({
    mutationFn: (variables: EnableGoogleAccountVariables) =>
      fetchEnableGoogleAccount({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DisableGoogleAccountPathParams = {
  /**
   * Google Account ID
   */
  id: string;
};

export type DisableGoogleAccountError = Fetcher.ErrorWrapper<undefined>;

export type DisableGoogleAccountResponse = {
  google_account: {
    data: Schemas.GoogleAccount;
  };
};

export type DisableGoogleAccountVariables = {
  pathParams: DisableGoogleAccountPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchDisableGoogleAccount = (
  variables: DisableGoogleAccountVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    DisableGoogleAccountResponse,
    DisableGoogleAccountError,
    undefined,
    {},
    {},
    DisableGoogleAccountPathParams
  >({
    url: "/google_accounts/{id}/disable",
    method: "post",
    ...variables,
    signal,
  });

export const useDisableGoogleAccount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      DisableGoogleAccountResponse,
      DisableGoogleAccountError,
      DisableGoogleAccountVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    DisableGoogleAccountResponse,
    DisableGoogleAccountError,
    DisableGoogleAccountVariables
  >({
    mutationFn: (variables: DisableGoogleAccountVariables) =>
      fetchDisableGoogleAccount({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ActivateGoogleAccountCalendarsPathParams = {
  /**
   * Google Account ID
   */
  id: string;
};

export type ActivateGoogleAccountCalendarsError =
  Fetcher.ErrorWrapper<undefined>;

export type ActivateGoogleAccountCalendarsResponse = {
  google_calendars: {
    data: Schemas.GoogleCalendar[];
  };
};

export type ActivateGoogleAccountCalendarsRequestBody = {
  google_account?: {
    /**
     * List of calendars to activate
     */
    calendar_ids: any[];
  };
  required?: void;
};

export type ActivateGoogleAccountCalendarsVariables = {
  body?: ActivateGoogleAccountCalendarsRequestBody;
  pathParams: ActivateGoogleAccountCalendarsPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchActivateGoogleAccountCalendars = (
  variables: ActivateGoogleAccountCalendarsVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ActivateGoogleAccountCalendarsResponse,
    ActivateGoogleAccountCalendarsError,
    ActivateGoogleAccountCalendarsRequestBody,
    {},
    {},
    ActivateGoogleAccountCalendarsPathParams
  >({
    url: "/google_accounts/{id}/activate",
    method: "post",
    ...variables,
    signal,
  });

export const useActivateGoogleAccountCalendars = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ActivateGoogleAccountCalendarsResponse,
      ActivateGoogleAccountCalendarsError,
      ActivateGoogleAccountCalendarsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    ActivateGoogleAccountCalendarsResponse,
    ActivateGoogleAccountCalendarsError,
    ActivateGoogleAccountCalendarsVariables
  >({
    mutationFn: (variables: ActivateGoogleAccountCalendarsVariables) =>
      fetchActivateGoogleAccountCalendars({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UserProfileError = Fetcher.ErrorWrapper<{
  status: 401;
  payload: Schemas.ErrorResponse;
}>;

export type UserProfileResponse = {
  user: {
    data: Schemas.User;
  };
  experiments?: {
    name: string;
    code: string;
    state: "active" | "disabled";
  }[];
};

export type UserProfileVariables = CalendarContext["fetcherOptions"];

export const fetchUserProfile = (
  variables: UserProfileVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<UserProfileResponse, UserProfileError, undefined, {}, {}, {}>({
    url: "/auth/profile",
    method: "get",
    ...variables,
    signal,
  });

export const useUserProfile = <TData = UserProfileResponse,>(
  variables: UserProfileVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<UserProfileResponse, UserProfileError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<UserProfileResponse, UserProfileError, TData>({
    queryKey: queryKeyFn({
      path: "/auth/profile",
      operationId: "userProfile",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchUserProfile({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type UserLoginError = Fetcher.ErrorWrapper<undefined>;

export type UserLoginResponse = {
  user: {
    data: Schemas.User;
  };
  /**
   * JWT Token
   */
  token: string;
};

export type UserLoginRequestBody = {
  /**
   * user data hash from Telegram call
   */
  user_data: string;
  /**
   * user timezone, IANA format
   *
   * @example Europe/London
   */
  timezone?: string;
  /**
   * ID token to auth (only for staging)
   */
  token_id?: number;
  /**
   * Ad campaign from
   */
  ad_source?: string;
};

export type UserLoginVariables = {
  body: UserLoginRequestBody;
} & CalendarContext["fetcherOptions"];

export const fetchUserLogin = (
  variables: UserLoginVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    UserLoginResponse,
    UserLoginError,
    UserLoginRequestBody,
    {},
    {},
    {}
  >({ url: "/auth/login", method: "post", ...variables, signal });

export const useUserLogin = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      UserLoginResponse,
      UserLoginError,
      UserLoginVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    UserLoginResponse,
    UserLoginError,
    UserLoginVariables
  >({
    mutationFn: (variables: UserLoginVariables) =>
      fetchUserLogin({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ListBirthdaysError = Fetcher.ErrorWrapper<undefined>;

export type ListBirthdaysResponse = {
  enabled: boolean;
  calendar_available: boolean;
  calendar_default_on: boolean;
  /**
   * @format date
   */
  today: string;
  my_birthday: {
    month: number;
    day: number;
  } | null;
  add_to_group_url: string;
  groups: Schemas.BirthdayGroup[];
  birthdays: Schemas.Birthday[];
};

export type ListBirthdaysVariables = CalendarContext["fetcherOptions"];

export const fetchListBirthdays = (
  variables: ListBirthdaysVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListBirthdaysResponse,
    ListBirthdaysError,
    undefined,
    {},
    {},
    {}
  >({ url: "/birthdays", method: "get", ...variables, signal });

export const useListBirthdays = <TData = ListBirthdaysResponse,>(
  variables: ListBirthdaysVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListBirthdaysResponse,
      ListBirthdaysError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<ListBirthdaysResponse, ListBirthdaysError, TData>({
    queryKey: queryKeyFn({
      path: "/birthdays",
      operationId: "listBirthdays",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListBirthdays({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type AddBirthdayGroupToCalendarPathParams = {
  id: string;
};

export type AddBirthdayGroupToCalendarError = Fetcher.ErrorWrapper<undefined>;

export type AddBirthdayGroupToCalendarResponse = {
  enabled: boolean;
  calendar_available: boolean;
  calendar_default_on: boolean;
  /**
   * @format date
   */
  today: string;
  my_birthday: {
    month: number;
    day: number;
  } | null;
  add_to_group_url: string;
  groups: Schemas.BirthdayGroup[];
  birthdays: Schemas.Birthday[];
};

export type AddBirthdayGroupToCalendarVariables = {
  pathParams: AddBirthdayGroupToCalendarPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchAddBirthdayGroupToCalendar = (
  variables: AddBirthdayGroupToCalendarVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    AddBirthdayGroupToCalendarResponse,
    AddBirthdayGroupToCalendarError,
    undefined,
    {},
    {},
    AddBirthdayGroupToCalendarPathParams
  >({
    url: "/birthdays/groups/{id}/calendar",
    method: "post",
    ...variables,
    signal,
  });

export const useAddBirthdayGroupToCalendar = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      AddBirthdayGroupToCalendarResponse,
      AddBirthdayGroupToCalendarError,
      AddBirthdayGroupToCalendarVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    AddBirthdayGroupToCalendarResponse,
    AddBirthdayGroupToCalendarError,
    AddBirthdayGroupToCalendarVariables
  >({
    mutationFn: (variables: AddBirthdayGroupToCalendarVariables) =>
      fetchAddBirthdayGroupToCalendar({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RemoveBirthdayGroupFromCalendarPathParams = {
  id: string;
};

export type RemoveBirthdayGroupFromCalendarError =
  Fetcher.ErrorWrapper<undefined>;

export type RemoveBirthdayGroupFromCalendarResponse = {
  enabled: boolean;
  calendar_available: boolean;
  calendar_default_on: boolean;
  /**
   * @format date
   */
  today: string;
  my_birthday: {
    month: number;
    day: number;
  } | null;
  add_to_group_url: string;
  groups: Schemas.BirthdayGroup[];
  birthdays: Schemas.Birthday[];
};

export type RemoveBirthdayGroupFromCalendarVariables = {
  pathParams: RemoveBirthdayGroupFromCalendarPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchRemoveBirthdayGroupFromCalendar = (
  variables: RemoveBirthdayGroupFromCalendarVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    RemoveBirthdayGroupFromCalendarResponse,
    RemoveBirthdayGroupFromCalendarError,
    undefined,
    {},
    {},
    RemoveBirthdayGroupFromCalendarPathParams
  >({
    url: "/birthdays/groups/{id}/calendar",
    method: "delete",
    ...variables,
    signal,
  });

export const useRemoveBirthdayGroupFromCalendar = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      RemoveBirthdayGroupFromCalendarResponse,
      RemoveBirthdayGroupFromCalendarError,
      RemoveBirthdayGroupFromCalendarVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    RemoveBirthdayGroupFromCalendarResponse,
    RemoveBirthdayGroupFromCalendarError,
    RemoveBirthdayGroupFromCalendarVariables
  >({
    mutationFn: (variables: RemoveBirthdayGroupFromCalendarVariables) =>
      fetchRemoveBirthdayGroupFromCalendar({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ShowEventDraftPathParams = {
  id: string;
};

export type ShowEventDraftError = Fetcher.ErrorWrapper<undefined>;

export type ShowEventDraftResponse = {
  event_draft: Schemas.EventDraft;
};

export type ShowEventDraftVariables = {
  pathParams: ShowEventDraftPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchShowEventDraft = (
  variables: ShowEventDraftVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ShowEventDraftResponse,
    ShowEventDraftError,
    undefined,
    {},
    {},
    ShowEventDraftPathParams
  >({ url: "/event_drafts/{id}", method: "get", ...variables, signal });

export const useShowEventDraft = <TData = ShowEventDraftResponse,>(
  variables: ShowEventDraftVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ShowEventDraftResponse,
      ShowEventDraftError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ShowEventDraftResponse,
    ShowEventDraftError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/event_drafts/{id}",
      operationId: "showEventDraft",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowEventDraft({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type DeleteEventDraftPathParams = {
  id: string;
};

export type DeleteEventDraftError = Fetcher.ErrorWrapper<undefined>;

export type DeleteEventDraftResponse = {
  event_draft: Schemas.EventDraft;
};

export type DeleteEventDraftVariables = {
  pathParams: DeleteEventDraftPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchDeleteEventDraft = (
  variables: DeleteEventDraftVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    DeleteEventDraftResponse,
    DeleteEventDraftError,
    undefined,
    {},
    {},
    DeleteEventDraftPathParams
  >({ url: "/event_drafts/{id}", method: "delete", ...variables, signal });

export const useDeleteEventDraft = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      DeleteEventDraftResponse,
      DeleteEventDraftError,
      DeleteEventDraftVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    DeleteEventDraftResponse,
    DeleteEventDraftError,
    DeleteEventDraftVariables
  >({
    mutationFn: (variables: DeleteEventDraftVariables) =>
      fetchDeleteEventDraft({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ListFeatureFlagsError = Fetcher.ErrorWrapper<undefined>;

export type ListFeatureFlagsResponse = {
  feature_flags: Schemas.FeatureFlag[];
};

export type ListFeatureFlagsVariables = CalendarContext["fetcherOptions"];

export const fetchListFeatureFlags = (
  variables: ListFeatureFlagsVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListFeatureFlagsResponse,
    ListFeatureFlagsError,
    undefined,
    {},
    {},
    {}
  >({ url: "/feature_flags", method: "get", ...variables, signal });

export const useListFeatureFlags = <TData = ListFeatureFlagsResponse,>(
  variables: ListFeatureFlagsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListFeatureFlagsResponse,
      ListFeatureFlagsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ListFeatureFlagsResponse,
    ListFeatureFlagsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/feature_flags",
      operationId: "listFeatureFlags",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListFeatureFlags({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ShowUserProfileError = Fetcher.ErrorWrapper<{
  status: 401;
  payload: Schemas.ErrorResponse;
}>;

export type ShowUserProfileResponse = {
  user: Schemas.OjUser;
  experiments?: {
    name: string;
    code: string;
    state: "active" | "disabled";
  }[];
};

export type ShowUserProfileVariables = CalendarContext["fetcherOptions"];

export const fetchShowUserProfile = (
  variables: ShowUserProfileVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ShowUserProfileResponse,
    ShowUserProfileError,
    undefined,
    {},
    {},
    {}
  >({ url: "/profile", method: "get", ...variables, signal });

export const useShowUserProfile = <TData = ShowUserProfileResponse,>(
  variables: ShowUserProfileVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ShowUserProfileResponse,
      ShowUserProfileError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ShowUserProfileResponse,
    ShowUserProfileError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/profile",
      operationId: "showUserProfile",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowUserProfile({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type UpdateUserProfileError = Fetcher.ErrorWrapper<undefined>;

export type UpdateUserProfileResponse = {
  user: Schemas.OjUser;
  experiments?: {
    name: string;
    code: string;
    state: "active" | "disabled";
  }[];
};

export type UpdateUserProfileRequestBody = {
  /**
   * locale
   */
  language_code?: "en" | "ru" | "de" | "pt-BR" | "fr" | "zh-CN";
  /**
   * theme
   */
  theme?: "dark" | "light" | "system";
  /**
   * Enable/Disable zoom link in calls
   */
  call_zoom?: boolean;
  /**
   * Enable/Disable google meet link in calls
   */
  call_google_meet?: boolean;
  /**
   * Set default value for attend modal
   */
  notify_before?: number;
};

export type UpdateUserProfileVariables = {
  body?: UpdateUserProfileRequestBody;
} & CalendarContext["fetcherOptions"];

export const fetchUpdateUserProfile = (
  variables: UpdateUserProfileVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    UpdateUserProfileResponse,
    UpdateUserProfileError,
    UpdateUserProfileRequestBody,
    {},
    {},
    {}
  >({ url: "/profile", method: "patch", ...variables, signal });

export const useUpdateUserProfile = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      UpdateUserProfileResponse,
      UpdateUserProfileError,
      UpdateUserProfileVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    UpdateUserProfileResponse,
    UpdateUserProfileError,
    UpdateUserProfileVariables
  >({
    mutationFn: (variables: UpdateUserProfileVariables) =>
      fetchUpdateUserProfile({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ShowShortLinkPathParams = {
  key: string;
};

export type ShowShortLinkError = Fetcher.ErrorWrapper<undefined>;

export type ShowShortLinkResponse = {
  short_link: Schemas.ShortLink;
};

export type ShowShortLinkVariables = {
  pathParams: ShowShortLinkPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchShowShortLink = (
  variables: ShowShortLinkVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ShowShortLinkResponse,
    ShowShortLinkError,
    undefined,
    {},
    {},
    ShowShortLinkPathParams
  >({ url: "/short_links/{key}", method: "get", ...variables, signal });

export const useShowShortLink = <TData = ShowShortLinkResponse,>(
  variables: ShowShortLinkVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ShowShortLinkResponse,
      ShowShortLinkError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<ShowShortLinkResponse, ShowShortLinkError, TData>({
    queryKey: queryKeyFn({
      path: "/short_links/{key}",
      operationId: "showShortLink",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowShortLink({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateShortLinkError = Fetcher.ErrorWrapper<undefined>;

export type CreateShortLinkResponse = {
  short_link: Schemas.ShortLink;
};

export type CreateShortLinkRequestBody = {
  /**
   * ID of instance
   */
  instance_id: string;
  /**
   * type of instance
   */
  instance_type: "Event" | "Slot" | "Stack";
};

export type CreateShortLinkVariables = {
  body: CreateShortLinkRequestBody;
} & CalendarContext["fetcherOptions"];

export const fetchCreateShortLink = (
  variables: CreateShortLinkVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    CreateShortLinkResponse,
    CreateShortLinkError,
    CreateShortLinkRequestBody,
    {},
    {},
    {}
  >({ url: "/short_links", method: "post", ...variables, signal });

export const useCreateShortLink = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      CreateShortLinkResponse,
      CreateShortLinkError,
      CreateShortLinkVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    CreateShortLinkResponse,
    CreateShortLinkError,
    CreateShortLinkVariables
  >({
    mutationFn: (variables: CreateShortLinkVariables) =>
      fetchCreateShortLink({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ShowOwnSlotError = Fetcher.ErrorWrapper<undefined>;

export type ShowOwnSlotResponse = {
  slot: Schemas.OwnSlot;
};

export type ShowOwnSlotVariables = CalendarContext["fetcherOptions"];

export const fetchShowOwnSlot = (
  variables: ShowOwnSlotVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<ShowOwnSlotResponse, ShowOwnSlotError, undefined, {}, {}, {}>({
    url: "/slot",
    method: "get",
    ...variables,
    signal,
  });

export const useShowOwnSlot = <TData = ShowOwnSlotResponse,>(
  variables: ShowOwnSlotVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<ShowOwnSlotResponse, ShowOwnSlotError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<ShowOwnSlotResponse, ShowOwnSlotError, TData>({
    queryKey: queryKeyFn({
      path: "/slot",
      operationId: "showOwnSlot",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowOwnSlot({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateSlotError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: Schemas.ErrorResponse;
}>;

export type CreateSlotResponse = {
  slot: Schemas.OwnSlot;
};

export type CreateSlotRequestBody = {
  /**
   * Slot element duration
   */
  slot_size: number;
  /**
   * time zone of schedule
   */
  time_zone?: string;
  /**
   * make agenda field is necessary
   */
  is_agenda_enabled?: boolean;
  meeting_provider?: "zoom" | "google_meet" | "none" | "custom_link";
  video_link?: string | null;
  /**
   * Availability type for slot booking window
   *
   * @default infinitely
   */
  availability_type?: "infinitely" | "range" | "rolling_window";
  /**
   * Start date for range availability type (required when availability_type is range)
   *
   * @format date
   * @example 2024-01-01
   */
  availability_start_date?: string;
  /**
   * End date for range availability type (required when availability_type is range)
   *
   * @format date
   * @example 2024-12-31
   */
  availability_end_date?: string;
  /**
   * Number of days forward for rolling_window availability type (required when availability_type is rolling_window)
   *
   * @minimum 1
   * @example 30
   */
  rolling_days?: number;
  schedule: {
    monday?: Schemas.ScheduleForDay;
    tuesday?: Schemas.ScheduleForDay;
    wednesday?: Schemas.ScheduleForDay;
    thursday?: Schemas.ScheduleForDay;
    friday?: Schemas.ScheduleForDay;
    saturday?: Schemas.ScheduleForDay;
    sunday?: Schemas.ScheduleForDay;
  };
};

export type CreateSlotVariables = {
  body: CreateSlotRequestBody;
} & CalendarContext["fetcherOptions"];

export const fetchCreateSlot = (
  variables: CreateSlotVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    CreateSlotResponse,
    CreateSlotError,
    CreateSlotRequestBody,
    {},
    {},
    {}
  >({ url: "/slot", method: "post", ...variables, signal });

export const useCreateSlot = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      CreateSlotResponse,
      CreateSlotError,
      CreateSlotVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    CreateSlotResponse,
    CreateSlotError,
    CreateSlotVariables
  >({
    mutationFn: (variables: CreateSlotVariables) =>
      fetchCreateSlot({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateSlotError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: Schemas.ErrorResponse;
}>;

export type UpdateSlotResponse = {
  slot: Schemas.OwnSlot;
};

export type UpdateSlotRequestBody = {
  meeting_provider?: "zoom" | "google_meet" | "none" | "custom_link";
  video_link?: string | null;
  /**
   * Slot element duration
   */
  slot_size?: number;
  /**
   * Make agenda necessary field
   */
  is_agenda_enabled?: boolean;
  /**
   * time zone of schedule
   */
  time_zone?: string;
  /**
   * Availability type for slot booking window
   *
   * @default infinitely
   */
  availability_type?: "infinitely" | "range" | "rolling_window";
  /**
   * Start date for range availability type (required when availability_type is range)
   *
   * @format date
   * @example 2024-01-01
   */
  availability_start_date?: string;
  /**
   * End date for range availability type (required when availability_type is range)
   *
   * @format date
   * @example 2024-12-31
   */
  availability_end_date?: string;
  /**
   * Number of days forward for rolling_window availability type (required when availability_type is rolling_window)
   *
   * @minimum 1
   * @example 30
   */
  rolling_days?: number;
  schedule?: {
    monday?: Schemas.ScheduleForDay;
    tuesday?: Schemas.ScheduleForDay;
    wednesday?: Schemas.ScheduleForDay;
    thursday?: Schemas.ScheduleForDay;
    friday?: Schemas.ScheduleForDay;
    saturday?: Schemas.ScheduleForDay;
    sunday?: Schemas.ScheduleForDay;
  };
};

export type UpdateSlotVariables = {
  body?: UpdateSlotRequestBody;
} & CalendarContext["fetcherOptions"];

export const fetchUpdateSlot = (
  variables: UpdateSlotVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    UpdateSlotResponse,
    UpdateSlotError,
    UpdateSlotRequestBody,
    {},
    {},
    {}
  >({ url: "/slot", method: "patch", ...variables, signal });

export const useUpdateSlot = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      UpdateSlotResponse,
      UpdateSlotError,
      UpdateSlotVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    UpdateSlotResponse,
    UpdateSlotError,
    UpdateSlotVariables
  >({
    mutationFn: (variables: UpdateSlotVariables) =>
      fetchUpdateSlot({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type EnableOwnSlotError = Fetcher.ErrorWrapper<undefined>;

export type EnableOwnSlotResponse = {
  slot: Schemas.OwnSlot;
};

export type EnableOwnSlotVariables = CalendarContext["fetcherOptions"];

export const fetchEnableOwnSlot = (
  variables: EnableOwnSlotVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    EnableOwnSlotResponse,
    EnableOwnSlotError,
    undefined,
    {},
    {},
    {}
  >({ url: "/slot/enable", method: "post", ...variables, signal });

export const useEnableOwnSlot = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      EnableOwnSlotResponse,
      EnableOwnSlotError,
      EnableOwnSlotVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    EnableOwnSlotResponse,
    EnableOwnSlotError,
    EnableOwnSlotVariables
  >({
    mutationFn: (variables: EnableOwnSlotVariables) =>
      fetchEnableOwnSlot({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DisableOwnSlotError = Fetcher.ErrorWrapper<undefined>;

export type DisableOwnSlotResponse = {
  slot: Schemas.OwnSlot;
};

export type DisableOwnSlotVariables = CalendarContext["fetcherOptions"];

export const fetchDisableOwnSlot = (
  variables: DisableOwnSlotVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    DisableOwnSlotResponse,
    DisableOwnSlotError,
    undefined,
    {},
    {},
    {}
  >({ url: "/slot/disable", method: "post", ...variables, signal });

export const useDisableOwnSlot = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      DisableOwnSlotResponse,
      DisableOwnSlotError,
      DisableOwnSlotVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    DisableOwnSlotResponse,
    DisableOwnSlotError,
    DisableOwnSlotVariables
  >({
    mutationFn: (variables: DisableOwnSlotVariables) =>
      fetchDisableOwnSlot({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type EnableGoogleMeetForSlotError = Fetcher.ErrorWrapper<undefined>;

export type EnableGoogleMeetForSlotResponse = {
  slot: Schemas.OwnSlot;
};

export type EnableGoogleMeetForSlotVariables =
  CalendarContext["fetcherOptions"];

export const fetchEnableGoogleMeetForSlot = (
  variables: EnableGoogleMeetForSlotVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    EnableGoogleMeetForSlotResponse,
    EnableGoogleMeetForSlotError,
    undefined,
    {},
    {},
    {}
  >({ url: "/slot/enable_google_meet", method: "post", ...variables, signal });

export const useEnableGoogleMeetForSlot = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      EnableGoogleMeetForSlotResponse,
      EnableGoogleMeetForSlotError,
      EnableGoogleMeetForSlotVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    EnableGoogleMeetForSlotResponse,
    EnableGoogleMeetForSlotError,
    EnableGoogleMeetForSlotVariables
  >({
    mutationFn: (variables: EnableGoogleMeetForSlotVariables) =>
      fetchEnableGoogleMeetForSlot({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DisableGoogleMeetForSlotError = Fetcher.ErrorWrapper<undefined>;

export type DisableGoogleMeetForSlotResponse = {
  slot: Schemas.OwnSlot;
};

export type DisableGoogleMeetForSlotVariables =
  CalendarContext["fetcherOptions"];

export const fetchDisableGoogleMeetForSlot = (
  variables: DisableGoogleMeetForSlotVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    DisableGoogleMeetForSlotResponse,
    DisableGoogleMeetForSlotError,
    undefined,
    {},
    {},
    {}
  >({ url: "/slot/disable_google_meet", method: "post", ...variables, signal });

export const useDisableGoogleMeetForSlot = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      DisableGoogleMeetForSlotResponse,
      DisableGoogleMeetForSlotError,
      DisableGoogleMeetForSlotVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    DisableGoogleMeetForSlotResponse,
    DisableGoogleMeetForSlotError,
    DisableGoogleMeetForSlotVariables
  >({
    mutationFn: (variables: DisableGoogleMeetForSlotVariables) =>
      fetchDisableGoogleMeetForSlot({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ShowSlotPathParams = {
  /**
   * @example b55546ab-a065-4a1f-b024-30dae882c3b7
   */
  id: string;
};

export type ShowSlotQueryParams = {
  /**
   * @format date
   * @example 2024-12-31
   */
  date?: string;
  timezone?: string;
};

export type ShowSlotError = Fetcher.ErrorWrapper<undefined>;

export type ShowSlotResponse = {
  slot: Schemas.SlotWithSpaces;
};

export type ShowSlotVariables = {
  pathParams: ShowSlotPathParams;
  queryParams?: ShowSlotQueryParams;
} & CalendarContext["fetcherOptions"];

export const fetchShowSlot = (
  variables: ShowSlotVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ShowSlotResponse,
    ShowSlotError,
    undefined,
    {},
    ShowSlotQueryParams,
    ShowSlotPathParams
  >({ url: "/slots/{id}", method: "get", ...variables, signal });

export const useShowSlot = <TData = ShowSlotResponse,>(
  variables: ShowSlotVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<ShowSlotResponse, ShowSlotError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<ShowSlotResponse, ShowSlotError, TData>({
    queryKey: queryKeyFn({
      path: "/slots/{id}",
      operationId: "showSlot",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowSlot({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ShowSlotWithDaysPathParams = {
  /**
   * @example b55546ab-a065-4a1f-b024-30dae882c3b7
   */
  id: string;
};

export type ShowSlotWithDaysQueryParams = {
  /**
   * @format date
   * @example 2024-12-31
   */
  date?: string;
};

export type ShowSlotWithDaysError = Fetcher.ErrorWrapper<undefined>;

export type ShowSlotWithDaysResponse = {
  slot: Schemas.SlotWithDays;
};

export type ShowSlotWithDaysVariables = {
  pathParams: ShowSlotWithDaysPathParams;
  queryParams?: ShowSlotWithDaysQueryParams;
} & CalendarContext["fetcherOptions"];

export const fetchShowSlotWithDays = (
  variables: ShowSlotWithDaysVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ShowSlotWithDaysResponse,
    ShowSlotWithDaysError,
    undefined,
    {},
    ShowSlotWithDaysQueryParams,
    ShowSlotWithDaysPathParams
  >({ url: "/slots/{id}/days", method: "get", ...variables, signal });

export const useShowSlotWithDays = <TData = ShowSlotWithDaysResponse,>(
  variables: ShowSlotWithDaysVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ShowSlotWithDaysResponse,
      ShowSlotWithDaysError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ShowSlotWithDaysResponse,
    ShowSlotWithDaysError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/slots/{id}/days",
      operationId: "showSlotWithDays",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowSlotWithDays({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateSlotEventV2PathParams = {
  /**
   * @example b55546ab-a065-4a1f-b024-30dae882c3b7
   */
  slotId: string;
};

export type CreateSlotEventV2Error = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.SimpleErrorResponse;
}>;

export type CreateSlotEventV2Response = {
  event: Schemas.OjEvent;
};

export type CreateSlotEventV2RequestBody = {
  /**
   * meeting agenda
   */
  description?: string;
  /**
   * Event start date and time
   *
   * @example 2024-08-01T20:40:27+03:00
   * @format date-time
   */
  start_at: string;
  /**
   * Duration of event in minutes
   *
   * @minimum 1
   */
  duration: number;
  /**
   * Event timezone, IANA format
   *
   * @example Europe/London
   */
  timezone?: string;
  /**
   * Notify before minutes, possible values: 0, 1, 30, 60, 180, 1440: where 0 is no notification, 1 min is right before event
   *
   * @minimum 0
   */
  notify_before?: number;
  /**
   * Notify before in minutes: where [] is no notification, [1, 30] is one and thirty mins before event
   */
  notify_before_array?: number[];
};

export type CreateSlotEventV2Variables = {
  body: CreateSlotEventV2RequestBody;
  pathParams: CreateSlotEventV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchCreateSlotEventV2 = (
  variables: CreateSlotEventV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    CreateSlotEventV2Response,
    CreateSlotEventV2Error,
    CreateSlotEventV2RequestBody,
    {},
    {},
    CreateSlotEventV2PathParams
  >({ url: "/v2/slots/{slotId}/events", method: "post", ...variables, signal });

export const useCreateSlotEventV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      CreateSlotEventV2Response,
      CreateSlotEventV2Error,
      CreateSlotEventV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    CreateSlotEventV2Response,
    CreateSlotEventV2Error,
    CreateSlotEventV2Variables
  >({
    mutationFn: (variables: CreateSlotEventV2Variables) =>
      fetchCreateSlotEventV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateSlotShareLinkPathParams = {
  /**
   * Stack ID
   */
  id: string;
};

export type CreateSlotShareLinkError = Fetcher.ErrorWrapper<undefined>;

export type CreateSlotShareLinkResponse = {
  prepared_inline_message: {
    id: string;
    expiration_date: number;
  };
};

export type CreateSlotShareLinkRequestBody = {
  /**
   * token of bot
   */
  token_id?: string;
};

export type CreateSlotShareLinkVariables = {
  body?: CreateSlotShareLinkRequestBody;
  pathParams: CreateSlotShareLinkPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchCreateSlotShareLink = (
  variables: CreateSlotShareLinkVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    CreateSlotShareLinkResponse,
    CreateSlotShareLinkError,
    CreateSlotShareLinkRequestBody,
    {},
    {},
    CreateSlotShareLinkPathParams
  >({ url: "/slots/{id}/share_link", method: "post", ...variables, signal });

export const useCreateSlotShareLink = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      CreateSlotShareLinkResponse,
      CreateSlotShareLinkError,
      CreateSlotShareLinkVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    CreateSlotShareLinkResponse,
    CreateSlotShareLinkError,
    CreateSlotShareLinkVariables
  >({
    mutationFn: (variables: CreateSlotShareLinkVariables) =>
      fetchCreateSlotShareLink({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateStackChatConnectLinkPathParams = {
  stackId: string;
};

export type CreateStackChatConnectLinkError = Fetcher.ErrorWrapper<{
  status: 404;
  payload: Schemas.ErrorResponse;
}>;

export type CreateStackChatConnectLinkVariables = {
  pathParams: CreateStackChatConnectLinkPathParams;
} & CalendarContext["fetcherOptions"];

/**
 * Returns a single-use t.me/<bot>?startgroup=<token> link, valid for 24 hours. Owner only. Opening it lets the user pick a group; Telegram adds the bot and the chat is connected to this stack.
 */
export const fetchCreateStackChatConnectLink = (
  variables: CreateStackChatConnectLinkVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    Schemas.StackConnectLink,
    CreateStackChatConnectLinkError,
    undefined,
    {},
    {},
    CreateStackChatConnectLinkPathParams
  >({
    url: "/stacks/{stackId}/chat_link/connect_link",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Returns a single-use t.me/<bot>?startgroup=<token> link, valid for 24 hours. Owner only. Opening it lets the user pick a group; Telegram adds the bot and the chat is connected to this stack.
 */
export const useCreateStackChatConnectLink = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.StackConnectLink,
      CreateStackChatConnectLinkError,
      CreateStackChatConnectLinkVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    Schemas.StackConnectLink,
    CreateStackChatConnectLinkError,
    CreateStackChatConnectLinkVariables
  >({
    mutationFn: (variables: CreateStackChatConnectLinkVariables) =>
      fetchCreateStackChatConnectLink({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ConnectStackChatPathParams = {
  stackId: string;
};

export type ConnectStackChatError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.SimpleErrorResponse;
}>;

export type ConnectStackChatRequestBody = {
  /**
   * Telegram's own chat id
   */
  telegram_chat_id: string;
};

export type ConnectStackChatVariables = {
  body: ConnectStackChatRequestBody;
  pathParams: ConnectStackChatPathParams;
} & CalendarContext["fetcherOptions"];

/**
 * Owner only. Replaces whatever chat the stack was announcing into. The greeting posted into the chat is the check that the bot can write there, so a failure to post means no link is created.
 */
export const fetchConnectStackChat = (
  variables: ConnectStackChatVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    Schemas.StackChatLink,
    ConnectStackChatError,
    ConnectStackChatRequestBody,
    {},
    {},
    ConnectStackChatPathParams
  >({
    url: "/stacks/{stackId}/chat_link/connect",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Owner only. Replaces whatever chat the stack was announcing into. The greeting posted into the chat is the check that the bot can write there, so a failure to post means no link is created.
 */
export const useConnectStackChat = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.StackChatLink,
      ConnectStackChatError,
      ConnectStackChatVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    Schemas.StackChatLink,
    ConnectStackChatError,
    ConnectStackChatVariables
  >({
    mutationFn: (variables: ConnectStackChatVariables) =>
      fetchConnectStackChat({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DisconnectStackChatPathParams = {
  stackId: string;
};

export type DisconnectStackChatError = Fetcher.ErrorWrapper<undefined>;

export type DisconnectStackChatVariables = {
  pathParams: DisconnectStackChatPathParams;
} & CalendarContext["fetcherOptions"];

/**
 * Owner only, and silent: nothing is posted into the group. Announcements already posted are left where they are.
 */
export const fetchDisconnectStackChat = (
  variables: DisconnectStackChatVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    undefined,
    DisconnectStackChatError,
    undefined,
    {},
    {},
    DisconnectStackChatPathParams
  >({
    url: "/stacks/{stackId}/chat_link/disconnect",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Owner only, and silent: nothing is posted into the group. Announcements already posted are left where they are.
 */
export const useDisconnectStackChat = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DisconnectStackChatError,
      DisconnectStackChatVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    undefined,
    DisconnectStackChatError,
    DisconnectStackChatVariables
  >({
    mutationFn: (variables: DisconnectStackChatVariables) =>
      fetchDisconnectStackChat({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ListStackEventsPathParams = {
  stackId: string;
};

export type ListStackEventsQueryParams = {
  page_number?: string;
  page_size?: string;
  status?: ("passed" | "upcoming")[];
};

export type ListStackEventsError = Fetcher.ErrorWrapper<undefined>;

export type ListStackEventsResponse = {
  /**
   * @example {"date":"2021-01-01","events":[{"id":1,"token":"3de3a0aef7df60128f328c0e976d","recurrent_type":0,"event_type":"event","attend_status":-1,"type":"stack_event","user":{"id":38,"first_name":"Pavel","last_name":null,"photo_url":null,"type":"small_user"},"title":"Important event","description":"Event description","start_at":"2024-11-13T20:43:05.473Z","duration":10,"timezone":null,"location":null,"video_link":null,"notify_before":0}]}
   */
  stack_events: {
    date: string;
    events: Schemas.StackEvent[];
  }[];
};

export type ListStackEventsVariables = {
  pathParams: ListStackEventsPathParams;
  queryParams?: ListStackEventsQueryParams;
} & CalendarContext["fetcherOptions"];

export const fetchListStackEvents = (
  variables: ListStackEventsVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListStackEventsResponse,
    ListStackEventsError,
    undefined,
    {},
    ListStackEventsQueryParams,
    ListStackEventsPathParams
  >({ url: "/stacks/{stackId}/events", method: "get", ...variables, signal });

export const useListStackEvents = <TData = ListStackEventsResponse,>(
  variables: ListStackEventsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListStackEventsResponse,
      ListStackEventsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ListStackEventsResponse,
    ListStackEventsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/stacks/{stackId}/events",
      operationId: "listStackEvents",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListStackEvents({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ListStackMembersPathParams = {
  stackId: string;
};

export type ListStackMembersQueryParams = {
  page_number?: string;
  page_size?: string;
  status?: ("passed" | "upcoming")[];
};

export type ListStackMembersError = Fetcher.ErrorWrapper<undefined>;

export type ListStackMembersResponse = {
  /**
   * @example {"users":[{"role":"creator","user":{"id":"666","first_name":"Sladkiy","last_name":"Pirozhok","photo_url":"https://t.me/i/userpic/320/S00ufiTmzRMULrXQNyiIRUWPJ8j7vaUIVA9TZn2urgE.svg","type":"small_user"}}]}
   */
  users: Schemas.Member[];
};

export type ListStackMembersVariables = {
  pathParams: ListStackMembersPathParams;
  queryParams?: ListStackMembersQueryParams;
} & CalendarContext["fetcherOptions"];

export const fetchListStackMembers = (
  variables: ListStackMembersVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListStackMembersResponse,
    ListStackMembersError,
    undefined,
    {},
    ListStackMembersQueryParams,
    ListStackMembersPathParams
  >({ url: "/stacks/{stackId}/members", method: "get", ...variables, signal });

export const useListStackMembers = <TData = ListStackMembersResponse,>(
  variables: ListStackMembersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListStackMembersResponse,
      ListStackMembersError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ListStackMembersResponse,
    ListStackMembersError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/stacks/{stackId}/members",
      operationId: "listStackMembers",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListStackMembers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ListStackSubscriptionsPathParams = {
  stackId: string;
};

export type ListStackSubscriptionsQueryParams = {
  page_number?: number;
  page_size?: number;
};

export type ListStackSubscriptionsError = Fetcher.ErrorWrapper<undefined>;

export type ListStackSubscriptionsResponse = {
  stack_subscriptions: Schemas.StackSubscription[];
  meta: {
    count: number;
    page_number: number;
    page_size: number;
  };
};

export type ListStackSubscriptionsVariables = {
  pathParams: ListStackSubscriptionsPathParams;
  queryParams?: ListStackSubscriptionsQueryParams;
} & CalendarContext["fetcherOptions"];

export const fetchListStackSubscriptions = (
  variables: ListStackSubscriptionsVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListStackSubscriptionsResponse,
    ListStackSubscriptionsError,
    undefined,
    {},
    ListStackSubscriptionsQueryParams,
    ListStackSubscriptionsPathParams
  >({
    url: "/stacks/{stackId}/stack_subscriptions",
    method: "get",
    ...variables,
    signal,
  });

export const useListStackSubscriptions = <
  TData = ListStackSubscriptionsResponse,
>(
  variables: ListStackSubscriptionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListStackSubscriptionsResponse,
      ListStackSubscriptionsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ListStackSubscriptionsResponse,
    ListStackSubscriptionsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/stacks/{stackId}/stack_subscriptions",
      operationId: "listStackSubscriptions",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListStackSubscriptions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateStackSubscriptionPathParams = {
  stackId: string;
};

export type CreateStackSubscriptionError = Fetcher.ErrorWrapper<undefined>;

export type CreateStackSubscriptionVariables = {
  pathParams: CreateStackSubscriptionPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchCreateStackSubscription = (
  variables: CreateStackSubscriptionVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    Schemas.StackSubscription,
    CreateStackSubscriptionError,
    undefined,
    {},
    {},
    CreateStackSubscriptionPathParams
  >({
    url: "/stacks/{stackId}/stack_subscriptions",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateStackSubscription = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.StackSubscription,
      CreateStackSubscriptionError,
      CreateStackSubscriptionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    Schemas.StackSubscription,
    CreateStackSubscriptionError,
    CreateStackSubscriptionVariables
  >({
    mutationFn: (variables: CreateStackSubscriptionVariables) =>
      fetchCreateStackSubscription({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteStackSubscriptionPathParams = {
  stackId: string;
};

export type DeleteStackSubscriptionError = Fetcher.ErrorWrapper<undefined>;

export type DeleteStackSubscriptionVariables = {
  pathParams: DeleteStackSubscriptionPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchDeleteStackSubscription = (
  variables: DeleteStackSubscriptionVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    undefined,
    DeleteStackSubscriptionError,
    undefined,
    {},
    {},
    DeleteStackSubscriptionPathParams
  >({
    url: "/stacks/{stackId}/stack_subscriptions",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteStackSubscription = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteStackSubscriptionError,
      DeleteStackSubscriptionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    undefined,
    DeleteStackSubscriptionError,
    DeleteStackSubscriptionVariables
  >({
    mutationFn: (variables: DeleteStackSubscriptionVariables) =>
      fetchDeleteStackSubscription({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateStackSubscriptionPathParams = {
  id: string;
  stackId: string;
};

export type UpdateStackSubscriptionError = Fetcher.ErrorWrapper<undefined>;

export type UpdateStackSubscriptionRequestBody = {
  /**
   * Role
   */
  role?: "reader" | "creator" | "owner";
  /**
   * State of stack subscription
   */
  state?: "active" | "disabled";
};

export type UpdateStackSubscriptionVariables = {
  body?: UpdateStackSubscriptionRequestBody;
  pathParams: UpdateStackSubscriptionPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchUpdateStackSubscription = (
  variables: UpdateStackSubscriptionVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    Schemas.StackSubscription,
    UpdateStackSubscriptionError,
    UpdateStackSubscriptionRequestBody,
    {},
    {},
    UpdateStackSubscriptionPathParams
  >({
    url: "/stacks/{stackId}/stack_subscriptions/{id}",
    method: "patch",
    ...variables,
    signal,
  });

export const useUpdateStackSubscription = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.StackSubscription,
      UpdateStackSubscriptionError,
      UpdateStackSubscriptionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    Schemas.StackSubscription,
    UpdateStackSubscriptionError,
    UpdateStackSubscriptionVariables
  >({
    mutationFn: (variables: UpdateStackSubscriptionVariables) =>
      fetchUpdateStackSubscription({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ListStackQueryParams = {
  page_number?: number;
  page_size?: number;
  roles?: ("creator" | "reader" | "owner")[];
};

export type ListStackError = Fetcher.ErrorWrapper<undefined>;

export type ListStackResponse = {
  stacks: Schemas.Stack[];
  meta: {
    count: number;
    page_number: number;
    page_size: number;
  };
};

export type ListStackVariables = {
  queryParams?: ListStackQueryParams;
} & CalendarContext["fetcherOptions"];

export const fetchListStack = (
  variables: ListStackVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListStackResponse,
    ListStackError,
    undefined,
    {},
    ListStackQueryParams,
    {}
  >({ url: "/stacks", method: "get", ...variables, signal });

export const useListStack = <TData = ListStackResponse,>(
  variables: ListStackVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<ListStackResponse, ListStackError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<ListStackResponse, ListStackError, TData>({
    queryKey: queryKeyFn({
      path: "/stacks",
      operationId: "listStack",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListStack({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateStackError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.MultipleErrorResponse;
}>;

export type CreateStackRequestBody = {
  stack: {
    /**
     * Event title
     */
    title: string;
    /**
     * Emoji
     *
     * @example 🐹
     */
    emoji?: string;
    /**
     * @default false
     */
    default_creator?: boolean;
  };
};

export type CreateStackVariables = {
  body: CreateStackRequestBody;
} & CalendarContext["fetcherOptions"];

export const fetchCreateStack = (
  variables: CreateStackVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    Schemas.Stack,
    CreateStackError,
    CreateStackRequestBody,
    {},
    {},
    {}
  >({ url: "/stacks", method: "post", ...variables, signal });

export const useCreateStack = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Stack,
      CreateStackError,
      CreateStackVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    Schemas.Stack,
    CreateStackError,
    CreateStackVariables
  >({
    mutationFn: (variables: CreateStackVariables) =>
      fetchCreateStack({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetStackPathParams = {
  id: string;
};

export type GetStackError = Fetcher.ErrorWrapper<undefined>;

export type GetStackVariables = {
  pathParams: GetStackPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchGetStack = (
  variables: GetStackVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    Schemas.Stack,
    GetStackError,
    undefined,
    {},
    {},
    GetStackPathParams
  >({ url: "/stacks/{id}", method: "get", ...variables, signal });

export const useGetStack = <TData = Schemas.Stack,>(
  variables: GetStackVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Stack, GetStackError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<Schemas.Stack, GetStackError, TData>({
    queryKey: queryKeyFn({
      path: "/stacks/{id}",
      operationId: "getStack",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetStack({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type UpdateStackPathParams = {
  id: string;
};

export type UpdateStackError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.MultipleErrorResponse;
}>;

export type UpdateStackRequestBody = {
  stack: {
    /**
     * Event title
     */
    title?: string;
    /**
     * Emoji
     *
     * @example 🐹
     */
    emoji?: string;
    /**
     * Visibility of stack
     */
    visibility?: "only_author" | "by_link" | "everyone";
    /**
     * State of stack
     */
    state?: "active" | "disabled";
    /**
     * @default false
     */
    default_creator?: boolean;
  };
};

export type UpdateStackVariables = {
  body: UpdateStackRequestBody;
  pathParams: UpdateStackPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchUpdateStack = (
  variables: UpdateStackVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    Schemas.Stack,
    UpdateStackError,
    UpdateStackRequestBody,
    {},
    {},
    UpdateStackPathParams
  >({ url: "/stacks/{id}", method: "patch", ...variables, signal });

export const useUpdateStack = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Stack,
      UpdateStackError,
      UpdateStackVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    Schemas.Stack,
    UpdateStackError,
    UpdateStackVariables
  >({
    mutationFn: (variables: UpdateStackVariables) =>
      fetchUpdateStack({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteStackPathParams = {
  id: string;
};

export type DeleteStackError = Fetcher.ErrorWrapper<undefined>;

export type DeleteStackVariables = {
  pathParams: DeleteStackPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchDeleteStack = (
  variables: DeleteStackVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    undefined,
    DeleteStackError,
    undefined,
    {},
    {},
    DeleteStackPathParams
  >({ url: "/stacks/{id}", method: "delete", ...variables, signal });

export const useDeleteStack = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteStackError,
      DeleteStackVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    undefined,
    DeleteStackError,
    DeleteStackVariables
  >({
    mutationFn: (variables: DeleteStackVariables) =>
      fetchDeleteStack({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ShareStackViaBotPathParams = {
  stackId: string;
};

export type ShareStackViaBotError = Fetcher.ErrorWrapper<undefined>;

export type ShareStackViaBotVariables = {
  pathParams: ShareStackViaBotPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchShareStackViaBot = (
  variables: ShareStackViaBotVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    undefined,
    ShareStackViaBotError,
    undefined,
    {},
    {},
    ShareStackViaBotPathParams
  >({
    url: "/stacks/{stackId}/share_via_bot",
    method: "post",
    ...variables,
    signal,
  });

export const useShareStackViaBot = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ShareStackViaBotError,
      ShareStackViaBotVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    undefined,
    ShareStackViaBotError,
    ShareStackViaBotVariables
  >({
    mutationFn: (variables: ShareStackViaBotVariables) =>
      fetchShareStackViaBot({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ListEmojisQueryParams = {
  page_number?: string;
  page_size?: string;
};

export type ListEmojisError = Fetcher.ErrorWrapper<undefined>;

export type ListEmojisResponse = {
  emojis: Schemas.Emoji[];
  meta: {
    count: number;
    page_number: number;
    page_size: number;
  };
};

export type ListEmojisVariables = {
  queryParams?: ListEmojisQueryParams;
} & CalendarContext["fetcherOptions"];

export const fetchListEmojis = (
  variables: ListEmojisVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListEmojisResponse,
    ListEmojisError,
    undefined,
    {},
    ListEmojisQueryParams,
    {}
  >({ url: "/emojis", method: "get", ...variables, signal });

export const useListEmojis = <TData = ListEmojisResponse,>(
  variables: ListEmojisVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<ListEmojisResponse, ListEmojisError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<ListEmojisResponse, ListEmojisError, TData>({
    queryKey: queryKeyFn({
      path: "/emojis",
      operationId: "listEmojis",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListEmojis({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateStackShareLinkPathParams = {
  /**
   * Stack ID
   */
  id: string;
};

export type CreateStackShareLinkError = Fetcher.ErrorWrapper<undefined>;

export type CreateStackShareLinkResponse = {
  prepared_inline_message: {
    id: string;
    expiration_date: number;
  };
};

export type CreateStackShareLinkRequestBody = {
  /**
   * token of bot
   */
  token_id?: string;
};

export type CreateStackShareLinkVariables = {
  body?: CreateStackShareLinkRequestBody;
  pathParams: CreateStackShareLinkPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchCreateStackShareLink = (
  variables: CreateStackShareLinkVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    CreateStackShareLinkResponse,
    CreateStackShareLinkError,
    CreateStackShareLinkRequestBody,
    {},
    {},
    CreateStackShareLinkPathParams
  >({ url: "/stacks/{id}/share_link", method: "post", ...variables, signal });

export const useCreateStackShareLink = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      CreateStackShareLinkResponse,
      CreateStackShareLinkError,
      CreateStackShareLinkVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    CreateStackShareLinkResponse,
    CreateStackShareLinkError,
    CreateStackShareLinkVariables
  >({
    mutationFn: (variables: CreateStackShareLinkVariables) =>
      fetchCreateStackShareLink({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateStoryImageError = Fetcher.ErrorWrapper<undefined>;

export type CreateStoryImageResponse = {
  story: {
    url: string;
  };
};

export type CreateStoryImageRequestBody = {
  /**
   * ID of story background
   */
  story_background_id: string;
  /**
   * Event token
   */
  event_id: string;
};

export type CreateStoryImageVariables = {
  body: CreateStoryImageRequestBody;
} & CalendarContext["fetcherOptions"];

export const fetchCreateStoryImage = (
  variables: CreateStoryImageVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    CreateStoryImageResponse,
    CreateStoryImageError,
    CreateStoryImageRequestBody,
    {},
    {},
    {}
  >({ url: "/stories", method: "post", ...variables, signal });

export const useCreateStoryImage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      CreateStoryImageResponse,
      CreateStoryImageError,
      CreateStoryImageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    CreateStoryImageResponse,
    CreateStoryImageError,
    CreateStoryImageVariables
  >({
    mutationFn: (variables: CreateStoryImageVariables) =>
      fetchCreateStoryImage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ShowBackgroundsListError = Fetcher.ErrorWrapper<undefined>;

export type ShowBackgroundsListResponse = {
  story_backgrounds: Schemas.StoryBackground[];
};

export type ShowBackgroundsListVariables = CalendarContext["fetcherOptions"];

export const fetchShowBackgroundsList = (
  variables: ShowBackgroundsListVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ShowBackgroundsListResponse,
    ShowBackgroundsListError,
    undefined,
    {},
    {},
    {}
  >({ url: "/story_backgrounds", method: "get", ...variables, signal });

export const useShowBackgroundsList = <TData = ShowBackgroundsListResponse,>(
  variables: ShowBackgroundsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ShowBackgroundsListResponse,
      ShowBackgroundsListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ShowBackgroundsListResponse,
    ShowBackgroundsListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/story_backgrounds",
      operationId: "showBackgroundsList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowBackgroundsList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ShowStoryOverlayQueryParams = {
  /**
   * Event token
   */
  event_id: string;
};

export type ShowStoryOverlayError = Fetcher.ErrorWrapper<undefined>;

export type ShowStoryOverlayResponse = {
  story_overlay: {
    /**
     * data:image/png;base64,...
     */
    image: string;
  };
};

export type ShowStoryOverlayVariables = {
  queryParams: ShowStoryOverlayQueryParams;
} & CalendarContext["fetcherOptions"];

/**
 * The gradient, avatar, author, title and date of a story, drawn on a transparent 1080x1920 PNG and returned as a data URL. The picker lays it over a background's preview_url; POST /stories composites the same layer onto the chosen background.
 */
export const fetchShowStoryOverlay = (
  variables: ShowStoryOverlayVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ShowStoryOverlayResponse,
    ShowStoryOverlayError,
    undefined,
    {},
    ShowStoryOverlayQueryParams,
    {}
  >({ url: "/story_overlay", method: "get", ...variables, signal });

/**
 * The gradient, avatar, author, title and date of a story, drawn on a transparent 1080x1920 PNG and returned as a data URL. The picker lays it over a background's preview_url; POST /stories composites the same layer onto the chosen background.
 */
export const useShowStoryOverlay = <TData = ShowStoryOverlayResponse,>(
  variables: ShowStoryOverlayVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ShowStoryOverlayResponse,
      ShowStoryOverlayError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ShowStoryOverlayResponse,
    ShowStoryOverlayError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/story_overlay",
      operationId: "showStoryOverlay",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowStoryOverlay({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ListTelegramChatsQueryParams = {
  page_number?: number;
  page_size?: number;
};

export type ListTelegramChatsError = Fetcher.ErrorWrapper<undefined>;

export type ListTelegramChatsResponse = {
  telegram_chats: Schemas.TelegramChat[];
  meta: {
    count: number;
    page_number: number;
    page_size: number;
  };
};

export type ListTelegramChatsVariables = {
  queryParams?: ListTelegramChatsQueryParams;
} & CalendarContext["fetcherOptions"];

/**
 * NOT CURRENTLY USED BY THE MINI APP, and kept deliberately. The chooser screen it was built for was cut in favour of connecting exclusively through the t.me/<bot>?startgroup=<token> deep link. Kept because that is a reversible UI decision and the data behind it is required either way. Returns the chats the user added the bot to, plus the chats they have already connected a stack to; chats the bot has been removed from are excluded. This is our own record: Telegram offers no way to ask which groups a bot and a user share.
 */
export const fetchListTelegramChats = (
  variables: ListTelegramChatsVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListTelegramChatsResponse,
    ListTelegramChatsError,
    undefined,
    {},
    ListTelegramChatsQueryParams,
    {}
  >({ url: "/telegram_chats", method: "get", ...variables, signal });

/**
 * NOT CURRENTLY USED BY THE MINI APP, and kept deliberately. The chooser screen it was built for was cut in favour of connecting exclusively through the t.me/<bot>?startgroup=<token> deep link. Kept because that is a reversible UI decision and the data behind it is required either way. Returns the chats the user added the bot to, plus the chats they have already connected a stack to; chats the bot has been removed from are excluded. This is our own record: Telegram offers no way to ask which groups a bot and a user share.
 */
export const useListTelegramChats = <TData = ListTelegramChatsResponse,>(
  variables: ListTelegramChatsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListTelegramChatsResponse,
      ListTelegramChatsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ListTelegramChatsResponse,
    ListTelegramChatsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/telegram_chats",
      operationId: "listTelegramChats",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListTelegramChats({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateUserTokenError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: Schemas.ErrorResponse;
}>;

export type CreateUserTokenResponse = {
  token: string;
};

export type CreateUserTokenVariables = CalendarContext["fetcherOptions"];

export const fetchCreateUserToken = (
  variables: CreateUserTokenVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    CreateUserTokenResponse,
    CreateUserTokenError,
    undefined,
    {},
    {},
    {}
  >({ url: "/user_tokens", method: "post", ...variables, signal });

export const useCreateUserToken = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      CreateUserTokenResponse,
      CreateUserTokenError,
      CreateUserTokenVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    CreateUserTokenResponse,
    CreateUserTokenError,
    CreateUserTokenVariables
  >({
    mutationFn: (variables: CreateUserTokenVariables) =>
      fetchCreateUserToken({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ValidateUserTokenError = Fetcher.ErrorWrapper<
  | {
      status: 401;
      payload: Schemas.ErrorResponse;
    }
  | {
      status: 403;
      payload: Schemas.ErrorResponse;
    }
  | {
      status: 502;
      payload: Schemas.ErrorResponse;
    }
>;

export type ValidateUserTokenResponse = {
  /**
   * Status
   */
  status: string;
  /**
   * Email of connected google account
   */
  email: string;
  /**
   * Name of connected google account
   */
  name: string;
};

export type ValidateUserTokenRequestBody = {
  /**
   * User token
   */
  token: string;
  /**
   * Google credentials
   */
  google_credentials: string;
  /**
   * 1 - use local redirect uri, only on staging
   */
  local?: number;
};

export type ValidateUserTokenVariables = {
  body: ValidateUserTokenRequestBody;
} & CalendarContext["fetcherOptions"];

export const fetchValidateUserToken = (
  variables: ValidateUserTokenVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ValidateUserTokenResponse,
    ValidateUserTokenError,
    ValidateUserTokenRequestBody,
    {},
    {},
    {}
  >({ url: "/user_tokens/validate", method: "post", ...variables, signal });

export const useValidateUserToken = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ValidateUserTokenResponse,
      ValidateUserTokenError,
      ValidateUserTokenVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    ValidateUserTokenResponse,
    ValidateUserTokenError,
    ValidateUserTokenVariables
  >({
    mutationFn: (variables: ValidateUserTokenVariables) =>
      fetchValidateUserToken({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetSubscriptionPlansError = Fetcher.ErrorWrapper<{
  status: 401;
  payload: Schemas.ErrorResponse;
}>;

export type GetSubscriptionPlansResponse = {
  plans: Schemas.SubscriptionPlan[];
  meta: {
    /**
     * @example 2
     */
    total: number;
  };
};

export type GetSubscriptionPlansVariables = CalendarContext["fetcherOptions"];

export const fetchGetSubscriptionPlans = (
  variables: GetSubscriptionPlansVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    GetSubscriptionPlansResponse,
    GetSubscriptionPlansError,
    undefined,
    {},
    {},
    {}
  >({ url: "/v2/subscription_plans", method: "get", ...variables, signal });

export const useGetSubscriptionPlans = <TData = GetSubscriptionPlansResponse,>(
  variables: GetSubscriptionPlansVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetSubscriptionPlansResponse,
      GetSubscriptionPlansError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    GetSubscriptionPlansResponse,
    GetSubscriptionPlansError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/v2/subscription_plans",
      operationId: "getSubscriptionPlans",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetSubscriptionPlans({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateInvoiceLinkPathParams = {
  /**
   * ID of the subscription plan
   */
  id: string;
};

export type CreateInvoiceLinkError = Fetcher.ErrorWrapper<
  | {
      status: 401;
      payload: Schemas.ErrorResponse;
    }
  | {
      status: 404;
      payload: Schemas.ErrorResponse;
    }
>;

export type CreateInvoiceLinkResponse = {
  /**
   * @example https://t.me/xyz123
   */
  invoice_link: string;
};

export type CreateInvoiceLinkVariables = {
  pathParams: CreateInvoiceLinkPathParams;
} & CalendarContext["fetcherOptions"];

export const fetchCreateInvoiceLink = (
  variables: CreateInvoiceLinkVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    CreateInvoiceLinkResponse,
    CreateInvoiceLinkError,
    undefined,
    {},
    {},
    CreateInvoiceLinkPathParams
  >({
    url: "/v2/subscription_plans/{id}/create_invoice_link",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateInvoiceLink = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      CreateInvoiceLinkResponse,
      CreateInvoiceLinkError,
      CreateInvoiceLinkVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    CreateInvoiceLinkResponse,
    CreateInvoiceLinkError,
    CreateInvoiceLinkVariables
  >({
    mutationFn: (variables: CreateInvoiceLinkVariables) =>
      fetchCreateInvoiceLink({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetUnsubscribeReasonsError = Fetcher.ErrorWrapper<undefined>;

export type GetUnsubscribeReasonsResponse = {
  unsubscribe_reasons: (
    | "too_expensive"
    | "dont_need_pro_features"
    | "not_using_calendar_much"
    | "something_didnt_work_properly"
    | "switching_to_another_tool"
  )[];
};

export type GetUnsubscribeReasonsVariables = CalendarContext["fetcherOptions"];

/**
 * Returns available unsubscribe reasons for user subscriptions
 */
export const fetchGetUnsubscribeReasons = (
  variables: GetUnsubscribeReasonsVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    GetUnsubscribeReasonsResponse,
    GetUnsubscribeReasonsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/v2/subscriptions/unsubscribe_reasons",
    method: "get",
    ...variables,
    signal,
  });

/**
 * Returns available unsubscribe reasons for user subscriptions
 */
export const useGetUnsubscribeReasons = <
  TData = GetUnsubscribeReasonsResponse,
>(
  variables: GetUnsubscribeReasonsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetUnsubscribeReasonsResponse,
      GetUnsubscribeReasonsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    GetUnsubscribeReasonsResponse,
    GetUnsubscribeReasonsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/v2/subscriptions/unsubscribe_reasons",
      operationId: "getUnsubscribeReasons",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetUnsubscribeReasons({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CancelSubscriptionError = Fetcher.ErrorWrapper<undefined>;

export type CancelSubscriptionRequestBody = {
  /**
   * Reason for unsubscribing
   */
  unsubscribe_reason:
    | "too_expensive"
    | "dont_need_pro_features"
    | "not_using_calendar_much"
    | "something_didnt_work_properly"
    | "switching_to_another_tool";
};

export type CancelSubscriptionVariables = {
  body: CancelSubscriptionRequestBody;
} & CalendarContext["fetcherOptions"];

/**
 * Failed to cancel subscription due to external service error
 */
export const fetchCancelSubscription = (
  variables: CancelSubscriptionVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    undefined,
    CancelSubscriptionError,
    CancelSubscriptionRequestBody,
    {},
    {},
    {}
  >({ url: "/v2/subscriptions/cancel", method: "post", ...variables, signal });

/**
 * Failed to cancel subscription due to external service error
 */
export const useCancelSubscription = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      CancelSubscriptionError,
      CancelSubscriptionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    undefined,
    CancelSubscriptionError,
    CancelSubscriptionVariables
  >({
    mutationFn: (variables: CancelSubscriptionVariables) =>
      fetchCancelSubscription({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SetEventCoverPresetV2PathParams = {
  /**
   * Event ID or event token
   */
  id: string;
};

export type SetEventCoverPresetV2Error = Fetcher.ErrorWrapper<undefined>;

export type SetEventCoverPresetV2Response = {
  event: Schemas.OjEvent;
};

export type SetEventCoverPresetV2RequestBody = {
  /**
   * The art theme; null clears it to the neutral page
   */
  cover_preset?:
    | "party"
    | "love"
    | "travel"
    | "nature"
    | "film"
    | "drinks"
    | any
    | null;
};

export type SetEventCoverPresetV2Variables = {
  body?: SetEventCoverPresetV2RequestBody;
  pathParams: SetEventCoverPresetV2PathParams;
} & CalendarContext["fetcherOptions"];

/**
 * Author only. Refused (422) on events imported from Google Calendar; allowed on tCalendar events pushed to Google. Not an event update: participants are not told.
 */
export const fetchSetEventCoverPresetV2 = (
  variables: SetEventCoverPresetV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    SetEventCoverPresetV2Response,
    SetEventCoverPresetV2Error,
    SetEventCoverPresetV2RequestBody,
    {},
    {},
    SetEventCoverPresetV2PathParams
  >({
    url: "/v2/events/{id}/cover_preset",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Author only. Refused (422) on events imported from Google Calendar; allowed on tCalendar events pushed to Google. Not an event update: participants are not told.
 */
export const useSetEventCoverPresetV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      SetEventCoverPresetV2Response,
      SetEventCoverPresetV2Error,
      SetEventCoverPresetV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    SetEventCoverPresetV2Response,
    SetEventCoverPresetV2Error,
    SetEventCoverPresetV2Variables
  >({
    mutationFn: (variables: SetEventCoverPresetV2Variables) =>
      fetchSetEventCoverPresetV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ListEventV2QueryParams = {
  /**
   * Filter events DateTime from
   */
  from?: string;
  /**
   * Filter events DateTime to
   */
  to?: string;
};

export type ListEventV2Error = Fetcher.ErrorWrapper<undefined>;

export type ListEventV2Response = {
  events: Schemas.OjEvent[];
};

export type ListEventV2Variables = {
  queryParams?: ListEventV2QueryParams;
} & CalendarContext["fetcherOptions"];

export const fetchListEventV2 = (
  variables: ListEventV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListEventV2Response,
    ListEventV2Error,
    undefined,
    {},
    ListEventV2QueryParams,
    {}
  >({ url: "/v2/events", method: "get", ...variables, signal });

export const useListEventV2 = <TData = ListEventV2Response,>(
  variables: ListEventV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<ListEventV2Response, ListEventV2Error, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<ListEventV2Response, ListEventV2Error, TData>({
    queryKey: queryKeyFn({
      path: "/v2/events",
      operationId: "listEventV2",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListEventV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateEventV2Error = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.MultipleErrorResponse;
}>;

export type CreateEventV2Response = {
  event: Schemas.OjEvent;
};

export type CreateEventV2RequestBody = {
  /**
   * Event title
   */
  title: string;
  /**
   * Event description
   */
  description?: string;
  /**
   * Event start date and time
   *
   * @example 2024-08-01T20:40:27+03:00
   * @format date-time
   */
  start_at: string;
  /**
   * Duration of event in minutes
   *
   * @minimum 1
   */
  duration: number;
  /**
   * Event timezone, IANA format
   *
   * @example Europe/London
   */
  timezone?: string;
  /**
   * Event location
   *
   * @example London/UK
   */
  location?: string;
  /**
   * Link to zoom/meet
   *
   * @example zoom.us/join/faw24fhy
   */
  video_link?: string;
  /**
   * Deprecated
   *
   * @minimum 0
   */
  notify_before?: number;
  /**
   * Notify before in minutes: where [] is no notification, [1, 30] is one and thirty mins before event
   */
  notify_before_array?: number[];
  /**
   * Recurrent events, 0 - no reccurency, 1 - daily, 2 - weekly, 3 - monthly, 4 - yearly
   *
   * @minimum 0
   */
  recurrent_type: number;
  /**
   * ID стэка
   *
   * @example 666
   */
  stack_id?: string;
  /**
   * Draft event ID
   *
   * @example 666
   */
  event_draft_id?: string;
  /**
   * Array of user IDs to invite to the event
   */
  invited_user_ids?: string[];
  attach_links?: "google_meet" | "zoom" | "none" | "custom_link";
  /**
   * creator is automaticaly join to stack_event
   */
  join_to_stack_event: boolean;
};

export type CreateEventV2Variables = {
  body: CreateEventV2RequestBody;
} & CalendarContext["fetcherOptions"];

export const fetchCreateEventV2 = (
  variables: CreateEventV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    CreateEventV2Response,
    CreateEventV2Error,
    CreateEventV2RequestBody,
    {},
    {},
    {}
  >({ url: "/v2/events", method: "post", ...variables, signal });

export const useCreateEventV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      CreateEventV2Response,
      CreateEventV2Error,
      CreateEventV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    CreateEventV2Response,
    CreateEventV2Error,
    CreateEventV2Variables
  >({
    mutationFn: (variables: CreateEventV2Variables) =>
      fetchCreateEventV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateEventShareLinkV2PathParams = {
  /**
   * Event ID or event token
   */
  id: string;
};

export type CreateEventShareLinkV2Error = Fetcher.ErrorWrapper<undefined>;

export type CreateEventShareLinkV2Response = {
  prepared_inline_message: {
    id: string;
    expiration_date: number;
  };
};

export type CreateEventShareLinkV2RequestBody = {
  /**
   * token of bot
   */
  token_id?: string;
  /**
   * Include message content
   */
  include_message_content?: string;
};

export type CreateEventShareLinkV2Variables = {
  body?: CreateEventShareLinkV2RequestBody;
  pathParams: CreateEventShareLinkV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchCreateEventShareLinkV2 = (
  variables: CreateEventShareLinkV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    CreateEventShareLinkV2Response,
    CreateEventShareLinkV2Error,
    CreateEventShareLinkV2RequestBody,
    {},
    {},
    CreateEventShareLinkV2PathParams
  >({
    url: "/v2/events/{id}/share_link",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateEventShareLinkV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      CreateEventShareLinkV2Response,
      CreateEventShareLinkV2Error,
      CreateEventShareLinkV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    CreateEventShareLinkV2Response,
    CreateEventShareLinkV2Error,
    CreateEventShareLinkV2Variables
  >({
    mutationFn: (variables: CreateEventShareLinkV2Variables) =>
      fetchCreateEventShareLinkV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type OverlapEventsV2QueryParams = {
  /**
   * Time event starts
   */
  start_at: string;
  /**
   * Duration of event
   */
  duration: string;
};

export type OverlapEventsV2Error = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ErrorResponse;
}>;

export type OverlapEventsV2Response = {
  events: Schemas.OjEvent[];
};

export type OverlapEventsV2Variables = {
  queryParams: OverlapEventsV2QueryParams;
} & CalendarContext["fetcherOptions"];

export const fetchOverlapEventsV2 = (
  variables: OverlapEventsV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    OverlapEventsV2Response,
    OverlapEventsV2Error,
    undefined,
    {},
    OverlapEventsV2QueryParams,
    {}
  >({ url: "/v2/events/overlap", method: "get", ...variables, signal });

export const useOverlapEventsV2 = <TData = OverlapEventsV2Response,>(
  variables: OverlapEventsV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      OverlapEventsV2Response,
      OverlapEventsV2Error,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    OverlapEventsV2Response,
    OverlapEventsV2Error,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/v2/events/overlap",
      operationId: "overlapEventsV2",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchOverlapEventsV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ShowEventV2PathParams = {
  /**
   * Event ID or event token
   */
  id: string;
};

export type ShowEventV2Error = Fetcher.ErrorWrapper<undefined>;

export type ShowEventV2Response = {
  event: Schemas.OjEvent;
};

export type ShowEventV2Variables = {
  pathParams: ShowEventV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchShowEventV2 = (
  variables: ShowEventV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ShowEventV2Response,
    ShowEventV2Error,
    undefined,
    {},
    {},
    ShowEventV2PathParams
  >({ url: "/v2/events/{id}", method: "get", ...variables, signal });

export const useShowEventV2 = <TData = ShowEventV2Response,>(
  variables: ShowEventV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<ShowEventV2Response, ShowEventV2Error, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<ShowEventV2Response, ShowEventV2Error, TData>({
    queryKey: queryKeyFn({
      path: "/v2/events/{id}",
      operationId: "showEventV2",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowEventV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type UpdateEventV2PathParams = {
  id: string;
};

export type UpdateEventV2Error = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.MultipleErrorResponse;
}>;

export type UpdateEventV2Response = {
  event: Schemas.OjEvent;
};

export type UpdateEventV2RequestBody = {
  /**
   * Event title
   */
  title?: string;
  /**
   * Event description
   */
  description?: string;
  /**
   * Event start date and time
   *
   * @example 2024-08-01T20:40:27+03:00
   * @format date-time
   */
  start_at?: string;
  /**
   * Duration of event in minutes
   *
   * @minimum 1
   */
  duration?: number;
  /**
   * Event timezone, IANA format
   *
   * @example Europe/London
   */
  timezone?: string;
  /**
   * Event location
   *
   * @example London/UK
   */
  location?: string;
  /**
   * Link to zoom/meet
   *
   * @example zoom.us/join/faw24fhy
   */
  video_link?: string;
  /**
   * Deprecated
   *
   * @minimum 0
   */
  notify_before?: number;
  /**
   * Notify before in minutes: where [] is no notification, [1, 30] is one and thirty mins before event
   */
  notify_before_array?: number[];
  /**
   * 1 if update dependent events
   */
  dependent_update?: number;
  /**
   * Array of user IDs to invite to the event
   */
  invited_user_ids?: string[];
  /**
   * Array of user IDs to invite to the event
   */
  removed_user_ids?: string[];
  attach_links?: "google_meet" | "zoom" | "none" | "custom_link";
};

export type UpdateEventV2Variables = {
  body?: UpdateEventV2RequestBody;
  pathParams: UpdateEventV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchUpdateEventV2 = (
  variables: UpdateEventV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    UpdateEventV2Response,
    UpdateEventV2Error,
    UpdateEventV2RequestBody,
    {},
    {},
    UpdateEventV2PathParams
  >({ url: "/v2/events/{id}", method: "patch", ...variables, signal });

export const useUpdateEventV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      UpdateEventV2Response,
      UpdateEventV2Error,
      UpdateEventV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    UpdateEventV2Response,
    UpdateEventV2Error,
    UpdateEventV2Variables
  >({
    mutationFn: (variables: UpdateEventV2Variables) =>
      fetchUpdateEventV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteEventV2PathParams = {
  id: string;
};

export type DeleteEventV2Error = Fetcher.ErrorWrapper<undefined>;

export type DeleteEventV2RequestBody = {
  /**
   * 1 if delete dependent events
   */
  dependent_destroy?: number;
};

export type DeleteEventV2Variables = {
  body?: DeleteEventV2RequestBody;
  pathParams: DeleteEventV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchDeleteEventV2 = (
  variables: DeleteEventV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    undefined,
    DeleteEventV2Error,
    DeleteEventV2RequestBody,
    {},
    {},
    DeleteEventV2PathParams
  >({ url: "/v2/events/{id}", method: "delete", ...variables, signal });

export const useDeleteEventV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteEventV2Error,
      DeleteEventV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    undefined,
    DeleteEventV2Error,
    DeleteEventV2Variables
  >({
    mutationFn: (variables: DeleteEventV2Variables) =>
      fetchDeleteEventV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type MissEventV2PathParams = {
  id: string;
};

export type MissEventV2Error = Fetcher.ErrorWrapper<undefined>;

export type MissEventV2Response = {
  event: Schemas.OjEvent;
};

export type MissEventV2RequestBody = {
  /**
   * 1 if miss dependend events
   */
  dependent_miss?: number;
};

export type MissEventV2Variables = {
  body?: MissEventV2RequestBody;
  pathParams: MissEventV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchMissEventV2 = (
  variables: MissEventV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    MissEventV2Response,
    MissEventV2Error,
    MissEventV2RequestBody,
    {},
    {},
    MissEventV2PathParams
  >({ url: "/v2/events/{id}/miss", method: "delete", ...variables, signal });

export const useMissEventV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      MissEventV2Response,
      MissEventV2Error,
      MissEventV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    MissEventV2Response,
    MissEventV2Error,
    MissEventV2Variables
  >({
    mutationFn: (variables: MissEventV2Variables) =>
      fetchMissEventV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RemoveAttendeeFromEventV2PathParams = {
  id: string;
};

export type RemoveAttendeeFromEventV2Error = Fetcher.ErrorWrapper<{
  status: 404;
  payload: Schemas.ErrorResponse;
}>;

export type RemoveAttendeeFromEventV2Response = {
  event: Schemas.OjEvent;
};

export type RemoveAttendeeFromEventV2RequestBody = {
  /**
   * user id to remove
   */
  user_id: string;
  /**
   * true if user can join after removing
   */
  prevent_rejoining_to_event?: boolean;
  /**
   * 1 if remove from dependend events
   */
  dependent_destroy?: number;
};

export type RemoveAttendeeFromEventV2Variables = {
  body: RemoveAttendeeFromEventV2RequestBody;
  pathParams: RemoveAttendeeFromEventV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchRemoveAttendeeFromEventV2 = (
  variables: RemoveAttendeeFromEventV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    RemoveAttendeeFromEventV2Response,
    RemoveAttendeeFromEventV2Error,
    RemoveAttendeeFromEventV2RequestBody,
    {},
    {},
    RemoveAttendeeFromEventV2PathParams
  >({
    url: "/v2/events/{id}/remove_attendee",
    method: "delete",
    ...variables,
    signal,
  });

export const useRemoveAttendeeFromEventV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      RemoveAttendeeFromEventV2Response,
      RemoveAttendeeFromEventV2Error,
      RemoveAttendeeFromEventV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    RemoveAttendeeFromEventV2Response,
    RemoveAttendeeFromEventV2Error,
    RemoveAttendeeFromEventV2Variables
  >({
    mutationFn: (variables: RemoveAttendeeFromEventV2Variables) =>
      fetchRemoveAttendeeFromEventV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type NotifyEventV2PathParams = {
  id: string;
};

export type NotifyEventV2Error = Fetcher.ErrorWrapper<undefined>;

export type NotifyEventV2Response = {
  event: Schemas.OjEvent;
};

export type NotifyEventV2RequestBody = {
  /**
   * Deprecated
   */
  notify_before?: number;
  /**
   * Notify before in minutes: where [] is no notification, [1, 30] is one and thirty mins before event
   */
  notify_before_array: number[];
  /**
   * 1 if apply to dependend events
   */
  dependent_notify?: number;
};

export type NotifyEventV2Variables = {
  body: NotifyEventV2RequestBody;
  pathParams: NotifyEventV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchNotifyEventV2 = (
  variables: NotifyEventV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    NotifyEventV2Response,
    NotifyEventV2Error,
    NotifyEventV2RequestBody,
    {},
    {},
    NotifyEventV2PathParams
  >({ url: "/v2/events/{id}/notify", method: "post", ...variables, signal });

export const useNotifyEventV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      NotifyEventV2Response,
      NotifyEventV2Error,
      NotifyEventV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    NotifyEventV2Response,
    NotifyEventV2Error,
    NotifyEventV2Variables
  >({
    mutationFn: (variables: NotifyEventV2Variables) =>
      fetchNotifyEventV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AttendEventV2PathParams = {
  id: string;
};

export type AttendEventV2Error = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.MultipleErrorResponse;
}>;

export type AttendEventV2Response = {
  event: Schemas.OjEvent;
};

export type AttendEventV2RequestBody = {
  /**
   * 1 - attend to event, 2 - maybe attend to event
   */
  status: number;
  /**
   * 1 if attend to dependend events
   */
  dependent_attend?: number;
};

export type AttendEventV2Variables = {
  body: AttendEventV2RequestBody;
  pathParams: AttendEventV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchAttendEventV2 = (
  variables: AttendEventV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    AttendEventV2Response,
    AttendEventV2Error,
    AttendEventV2RequestBody,
    {},
    {},
    AttendEventV2PathParams
  >({ url: "/v2/events/{id}/attend", method: "post", ...variables, signal });

export const useAttendEventV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      AttendEventV2Response,
      AttendEventV2Error,
      AttendEventV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    AttendEventV2Response,
    AttendEventV2Error,
    AttendEventV2Variables
  >({
    mutationFn: (variables: AttendEventV2Variables) =>
      fetchAttendEventV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ListGoogleAccountsV2Error = Fetcher.ErrorWrapper<undefined>;

export type ListGoogleAccountsV2Response = {
  google_accounts: Schemas.OjGoogleAccount[];
  meta?: {
    /**
     * @example 2
     */
    total: number;
  };
};

export type ListGoogleAccountsV2Variables = CalendarContext["fetcherOptions"];

export const fetchListGoogleAccountsV2 = (
  variables: ListGoogleAccountsV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListGoogleAccountsV2Response,
    ListGoogleAccountsV2Error,
    undefined,
    {},
    {},
    {}
  >({ url: "/v2/google_accounts", method: "get", ...variables, signal });

export const useListGoogleAccountsV2 = <TData = ListGoogleAccountsV2Response,>(
  variables: ListGoogleAccountsV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListGoogleAccountsV2Response,
      ListGoogleAccountsV2Error,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ListGoogleAccountsV2Response,
    ListGoogleAccountsV2Error,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/v2/google_accounts",
      operationId: "listGoogleAccountsV2",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListGoogleAccountsV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ShowGoogleAccountV2PathParams = {
  /**
   * Google Account ID
   */
  id: string;
};

export type ShowGoogleAccountV2Error = Fetcher.ErrorWrapper<{
  status: 404;
  payload: Schemas.OjSingleError;
}>;

export type ShowGoogleAccountV2Response = {
  google_calendars: Schemas.OjGoogleCalendar[];
  meta?: {
    /**
     * @example 2
     */
    total: number;
  };
};

export type ShowGoogleAccountV2Variables = {
  pathParams: ShowGoogleAccountV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchShowGoogleAccountV2 = (
  variables: ShowGoogleAccountV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ShowGoogleAccountV2Response,
    ShowGoogleAccountV2Error,
    undefined,
    {},
    {},
    ShowGoogleAccountV2PathParams
  >({ url: "/v2/google_accounts/{id}", method: "get", ...variables, signal });

export const useShowGoogleAccountV2 = <TData = ShowGoogleAccountV2Response,>(
  variables: ShowGoogleAccountV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ShowGoogleAccountV2Response,
      ShowGoogleAccountV2Error,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ShowGoogleAccountV2Response,
    ShowGoogleAccountV2Error,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/v2/google_accounts/{id}",
      operationId: "showGoogleAccountV2",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowGoogleAccountV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type DeleteGoogleAccountV2PathParams = {
  /**
   * Google Account ID
   */
  id: string;
};

export type DeleteGoogleAccountV2QueryParams = {
  /**
   * Next primary Google Account ID
   */
  next_primary_account_id?: string;
};

export type DeleteGoogleAccountV2Error = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.OjSingleError;
}>;

export type DeleteGoogleAccountV2Variables = {
  pathParams: DeleteGoogleAccountV2PathParams;
  queryParams?: DeleteGoogleAccountV2QueryParams;
} & CalendarContext["fetcherOptions"];

export const fetchDeleteGoogleAccountV2 = (
  variables: DeleteGoogleAccountV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    undefined,
    DeleteGoogleAccountV2Error,
    undefined,
    {},
    DeleteGoogleAccountV2QueryParams,
    DeleteGoogleAccountV2PathParams
  >({
    url: "/v2/google_accounts/{id}",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteGoogleAccountV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteGoogleAccountV2Error,
      DeleteGoogleAccountV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    undefined,
    DeleteGoogleAccountV2Error,
    DeleteGoogleAccountV2Variables
  >({
    mutationFn: (variables: DeleteGoogleAccountV2Variables) =>
      fetchDeleteGoogleAccountV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ResyncGoogleAccountV2PathParams = {
  /**
   * Google Account ID
   */
  id: string;
};

export type ResyncGoogleAccountV2Error = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.OjSingleError;
}>;

export type ResyncGoogleAccountV2Response = {
  google_account: Schemas.OjGoogleAccount;
};

export type ResyncGoogleAccountV2Variables = {
  pathParams: ResyncGoogleAccountV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchResyncGoogleAccountV2 = (
  variables: ResyncGoogleAccountV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ResyncGoogleAccountV2Response,
    ResyncGoogleAccountV2Error,
    undefined,
    {},
    {},
    ResyncGoogleAccountV2PathParams
  >({
    url: "/v2/google_accounts/{id}/resync",
    method: "post",
    ...variables,
    signal,
  });

export const useResyncGoogleAccountV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ResyncGoogleAccountV2Response,
      ResyncGoogleAccountV2Error,
      ResyncGoogleAccountV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    ResyncGoogleAccountV2Response,
    ResyncGoogleAccountV2Error,
    ResyncGoogleAccountV2Variables
  >({
    mutationFn: (variables: ResyncGoogleAccountV2Variables) =>
      fetchResyncGoogleAccountV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ActivateGoogleAccountV2PathParams = {
  /**
   * Google Account ID
   */
  id: string;
};

export type ActivateGoogleAccountV2Error = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.OjSingleError;
}>;

export type ActivateGoogleAccountV2Response = {
  google_calendars: Schemas.OjGoogleCalendar[];
};

export type ActivateGoogleAccountV2RequestBody = {
  google_account?: {
    /**
     * List of calendars to activate
     */
    calendar_ids: any[];
  };
  required?: void;
};

export type ActivateGoogleAccountV2Variables = {
  body?: ActivateGoogleAccountV2RequestBody;
  pathParams: ActivateGoogleAccountV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchActivateGoogleAccountV2 = (
  variables: ActivateGoogleAccountV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ActivateGoogleAccountV2Response,
    ActivateGoogleAccountV2Error,
    ActivateGoogleAccountV2RequestBody,
    {},
    {},
    ActivateGoogleAccountV2PathParams
  >({
    url: "/v2/google_accounts/{id}/activate",
    method: "post",
    ...variables,
    signal,
  });

export const useActivateGoogleAccountV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ActivateGoogleAccountV2Response,
      ActivateGoogleAccountV2Error,
      ActivateGoogleAccountV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    ActivateGoogleAccountV2Response,
    ActivateGoogleAccountV2Error,
    ActivateGoogleAccountV2Variables
  >({
    mutationFn: (variables: ActivateGoogleAccountV2Variables) =>
      fetchActivateGoogleAccountV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SetAsPrimaryGoogleAccountV2PathParams = {
  /**
   * Google Account ID
   */
  id: string;
};

export type SetAsPrimaryGoogleAccountV2Error = Fetcher.ErrorWrapper<undefined>;

export type SetAsPrimaryGoogleAccountV2Response = {
  google_account: Schemas.OjGoogleAccount;
};

export type SetAsPrimaryGoogleAccountV2Variables = {
  pathParams: SetAsPrimaryGoogleAccountV2PathParams;
} & CalendarContext["fetcherOptions"];

export const fetchSetAsPrimaryGoogleAccountV2 = (
  variables: SetAsPrimaryGoogleAccountV2Variables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    SetAsPrimaryGoogleAccountV2Response,
    SetAsPrimaryGoogleAccountV2Error,
    undefined,
    {},
    {},
    SetAsPrimaryGoogleAccountV2PathParams
  >({
    url: "/v2/google_accounts/{id}/set_as_primary",
    method: "post",
    ...variables,
    signal,
  });

export const useSetAsPrimaryGoogleAccountV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      SetAsPrimaryGoogleAccountV2Response,
      SetAsPrimaryGoogleAccountV2Error,
      SetAsPrimaryGoogleAccountV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    SetAsPrimaryGoogleAccountV2Response,
    SetAsPrimaryGoogleAccountV2Error,
    SetAsPrimaryGoogleAccountV2Variables
  >({
    mutationFn: (variables: SetAsPrimaryGoogleAccountV2Variables) =>
      fetchSetAsPrimaryGoogleAccountV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ListParticipantsError = Fetcher.ErrorWrapper<{
  status: 401;
  payload: Schemas.ErrorResponse;
}>;

export type ListParticipantsResponse = {
  users: Schemas.OjUser[];
  meta: {
    total: number;
  };
};

export type ListParticipantsVariables = CalendarContext["fetcherOptions"];

export const fetchListParticipants = (
  variables: ListParticipantsVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ListParticipantsResponse,
    ListParticipantsError,
    undefined,
    {},
    {},
    {}
  >({ url: "/v2/participants", method: "get", ...variables, signal });

export const useListParticipants = <TData = ListParticipantsResponse,>(
  variables: ListParticipantsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListParticipantsResponse,
      ListParticipantsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ListParticipantsResponse,
    ListParticipantsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/v2/participants",
      operationId: "listParticipants",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchListParticipants({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ShowVersionError = Fetcher.ErrorWrapper<undefined>;

export type ShowVersionResponse = {
  /**
   * @example 472c8e2
   */
  revision: string;
};

export type ShowVersionVariables = CalendarContext["fetcherOptions"];

export const fetchShowVersion = (
  variables: ShowVersionVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<ShowVersionResponse, ShowVersionError, undefined, {}, {}, {}>({
    url: "/version",
    method: "get",
    ...variables,
    signal,
  });

export const useShowVersion = <TData = ShowVersionResponse,>(
  variables: ShowVersionVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<ShowVersionResponse, ShowVersionError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<ShowVersionResponse, ShowVersionError, TData>({
    queryKey: queryKeyFn({
      path: "/version",
      operationId: "showVersion",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowVersion({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ShowZoomProfileUrlError = Fetcher.ErrorWrapper<undefined>;

export type ShowZoomProfileUrlResponse = {
  name: string;
  email: string;
};

export type ShowZoomProfileUrlVariables = CalendarContext["fetcherOptions"];

export const fetchShowZoomProfileUrl = (
  variables: ShowZoomProfileUrlVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<
    ShowZoomProfileUrlResponse,
    ShowZoomProfileUrlError,
    undefined,
    {},
    {},
    {}
  >({ url: "/zoom", method: "get", ...variables, signal });

export const useShowZoomProfileUrl = <TData = ShowZoomProfileUrlResponse,>(
  variables: ShowZoomProfileUrlVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ShowZoomProfileUrlResponse,
      ShowZoomProfileUrlError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<
    ShowZoomProfileUrlResponse,
    ShowZoomProfileUrlError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/zoom",
      operationId: "showZoomProfileUrl",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchShowZoomProfileUrl({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type DeleteZoomProfileUrlError = Fetcher.ErrorWrapper<undefined>;

export type DeleteZoomProfileUrlVariables = CalendarContext["fetcherOptions"];

export const fetchDeleteZoomProfileUrl = (
  variables: DeleteZoomProfileUrlVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<undefined, DeleteZoomProfileUrlError, undefined, {}, {}, {}>({
    url: "/zoom",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteZoomProfileUrl = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteZoomProfileUrlError,
      DeleteZoomProfileUrlVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCalendarContext();
  return reactQuery.useMutation<
    undefined,
    DeleteZoomProfileUrlError,
    DeleteZoomProfileUrlVariables
  >({
    mutationFn: (variables: DeleteZoomProfileUrlVariables) =>
      fetchDeleteZoomProfileUrl({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ZoomAuthUrlError = Fetcher.ErrorWrapper<{
  status: 401;
  payload: Schemas.ErrorResponse;
}>;

export type ZoomAuthUrlResponse = {
  url: string;
};

export type ZoomAuthUrlVariables = CalendarContext["fetcherOptions"];

export const fetchZoomAuthUrl = (
  variables: ZoomAuthUrlVariables,
  signal?: AbortSignal,
) =>
  calendarFetch<ZoomAuthUrlResponse, ZoomAuthUrlError, undefined, {}, {}, {}>({
    url: "/zoom/auth",
    method: "get",
    ...variables,
    signal,
  });

export const useZoomAuthUrl = <TData = ZoomAuthUrlResponse,>(
  variables: ZoomAuthUrlVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<ZoomAuthUrlResponse, ZoomAuthUrlError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useCalendarContext(options);
  return reactQuery.useQuery<ZoomAuthUrlResponse, ZoomAuthUrlError, TData>({
    queryKey: queryKeyFn({
      path: "/zoom/auth",
      operationId: "zoomAuthUrl",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchZoomAuthUrl({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type QueryOperation =
  | {
      path: "/google_accounts";
      operationId: "listGoogleAccounts";
      variables: ListGoogleAccountsVariables;
    }
  | {
      path: "/google_accounts/{id}";
      operationId: "showGoogleAccount";
      variables: ShowGoogleAccountVariables;
    }
  | {
      path: "/auth/profile";
      operationId: "userProfile";
      variables: UserProfileVariables;
    }
  | {
      path: "/birthdays";
      operationId: "listBirthdays";
      variables: ListBirthdaysVariables;
    }
  | {
      path: "/event_drafts/{id}";
      operationId: "showEventDraft";
      variables: ShowEventDraftVariables;
    }
  | {
      path: "/feature_flags";
      operationId: "listFeatureFlags";
      variables: ListFeatureFlagsVariables;
    }
  | {
      path: "/profile";
      operationId: "showUserProfile";
      variables: ShowUserProfileVariables;
    }
  | {
      path: "/short_links/{key}";
      operationId: "showShortLink";
      variables: ShowShortLinkVariables;
    }
  | {
      path: "/slot";
      operationId: "showOwnSlot";
      variables: ShowOwnSlotVariables;
    }
  | {
      path: "/slots/{id}";
      operationId: "showSlot";
      variables: ShowSlotVariables;
    }
  | {
      path: "/slots/{id}/days";
      operationId: "showSlotWithDays";
      variables: ShowSlotWithDaysVariables;
    }
  | {
      path: "/stacks/{stackId}/events";
      operationId: "listStackEvents";
      variables: ListStackEventsVariables;
    }
  | {
      path: "/stacks/{stackId}/members";
      operationId: "listStackMembers";
      variables: ListStackMembersVariables;
    }
  | {
      path: "/stacks/{stackId}/stack_subscriptions";
      operationId: "listStackSubscriptions";
      variables: ListStackSubscriptionsVariables;
    }
  | {
      path: "/stacks";
      operationId: "listStack";
      variables: ListStackVariables;
    }
  | {
      path: "/stacks/{id}";
      operationId: "getStack";
      variables: GetStackVariables;
    }
  | {
      path: "/emojis";
      operationId: "listEmojis";
      variables: ListEmojisVariables;
    }
  | {
      path: "/story_backgrounds";
      operationId: "showBackgroundsList";
      variables: ShowBackgroundsListVariables;
    }
  | {
      path: "/story_overlay";
      operationId: "showStoryOverlay";
      variables: ShowStoryOverlayVariables;
    }
  | {
      path: "/telegram_chats";
      operationId: "listTelegramChats";
      variables: ListTelegramChatsVariables;
    }
  | {
      path: "/v2/subscription_plans";
      operationId: "getSubscriptionPlans";
      variables: GetSubscriptionPlansVariables;
    }
  | {
      path: "/v2/subscriptions/unsubscribe_reasons";
      operationId: "getUnsubscribeReasons";
      variables: GetUnsubscribeReasonsVariables;
    }
  | {
      path: "/v2/events";
      operationId: "listEventV2";
      variables: ListEventV2Variables;
    }
  | {
      path: "/v2/events/overlap";
      operationId: "overlapEventsV2";
      variables: OverlapEventsV2Variables;
    }
  | {
      path: "/v2/events/{id}";
      operationId: "showEventV2";
      variables: ShowEventV2Variables;
    }
  | {
      path: "/v2/google_accounts";
      operationId: "listGoogleAccountsV2";
      variables: ListGoogleAccountsV2Variables;
    }
  | {
      path: "/v2/google_accounts/{id}";
      operationId: "showGoogleAccountV2";
      variables: ShowGoogleAccountV2Variables;
    }
  | {
      path: "/v2/participants";
      operationId: "listParticipants";
      variables: ListParticipantsVariables;
    }
  | {
      path: "/version";
      operationId: "showVersion";
      variables: ShowVersionVariables;
    }
  | {
      path: "/zoom";
      operationId: "showZoomProfileUrl";
      variables: ShowZoomProfileUrlVariables;
    }
  | {
      path: "/zoom/auth";
      operationId: "zoomAuthUrl";
      variables: ZoomAuthUrlVariables;
    };
